<template>
  <nuxt-link v-slot="{ href, navigate }" custom :to="{ name: 'subscriptions' }">
    <li class="tree__item" :class="{ active: isActive }">
      <div class="tree__action sidebar__action">
        <a :href="href" class="tree__link" @click="navigate">
          <i class="tree__icon iconoir-credit-card"></i>
          <span class="tree__link-text">
            <span class="sidebar__item-name">{{
              $t('subscriptionMenuItem.content')
            }}</span>
          </span>
        </a>
      </div>
    </li>
  </nuxt-link>
</template>

<script>
// The subscription routes aren't nested, so the item is active on any of them.
const SUBSCRIPTION_ROUTE_NAMES = [
  'subscriptions',
  'new-subscription',
  'subscription',
]

export default {
  name: 'SidebarAllWorkspacesSubscriptions',
  computed: {
    isActive() {
      return SUBSCRIPTION_ROUTE_NAMES.includes(this.$route.name)
    },
  },
}
</script>
